<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.org_cname" :placeholder="$t('code_cname')">
                        <span slot="prepend">{{$t('org')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.addr">
                        <span slot="prepend">{{$t('addr')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed :label="$t('logo_img')" width="80px">
                        <template slot-scope="scope">
                            <myImgshow :src="scope.row.img_lnk" @onClick="$base.alertImg(scope.row.img_lnk, scope.row.org_cname)"></myImgshow>
                        </template>
                    </el-table-column>
                    <el-table-column fixed prop="org_code" :label="listHeader.org_code" width="100px"></el-table-column>
                    <el-table-column prop="org_cname" :label="listHeader.org_cname" width="150px"></el-table-column>
                    <el-table-column prop="link_cname" :label="listHeader.link_cname" width="100px"></el-table-column>
                    <el-table-column prop="link_mobile" :label="listHeader.link_mobile" width="110px"></el-table-column>
                    <el-table-column width="120px" prop="mod_cname">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.mod_cname" :list="mods" v-model="search.mod_id"
                                        title_class="f12 f-blue" key_name="mod_cname" value_name="mod_id" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column width="120px" prop="join_type_cname">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.join_type_cname" :list="join_type" v-model="search.join_type"
                                        title_class="f12 f-blue" key_name="type_cname" value_name="join_type" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column width="100px" prop="org_status_cdesc">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.org_status_cdesc" :list="org_status" v-model="search.org_status"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <template v-if="mod_cat == 'M1'">
                        <el-table-column prop="admin_code" :label="listHeader.admin_code" width="100px"></el-table-column>
                    </template>
                    <el-table-column prop="org_admin_code" :label="listHeader.org_admin_code" width="120px"></el-table-column>
                    <el-table-column :label="listHeader.addr" min-width="200px">
                        <template slot-scope="scope">{{scope.row.prov}}{{scope.row.city}}{{scope.row.area}}{{scope.row.addr}}</template>
                    </el-table-column>
                    <el-table-column prop="end_time" :label="listHeader.end_time" width="100px"></el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" width="140px"></el-table-column>
                    <el-table-column prop="org_id" label="ID" width="80px"></el-table-column>
                    <el-table-column fixed="right" :label="$t('op')" width="120px">
                        <template slot-scope="scope">
                            <a class="link" @click="openSave(scope.row.org_id)">{{$t('info')}}</a>
                            <a class="link" @click="openAdmin(scope.row)" v-if="mod_cat == 'M1'">{{$t('upd_admin_code')}}</a>
                            <a class="link" @click="openOrgAdmin(scope.row)">{{$t('upd_org_admin_code')}}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myDropdown from '../../../components/myDropdown'
    import myDatePicker from '../../../components/myDatePicker'
    import myImgshow from '../../../components/myImgshow'
    export default {
        name:"org-down",
        components:{
            myPager,
            myNodata,
            myDropdown,
            myDatePicker,
            myImgshow
        },
        data:function(){
            const listHeader = {
                img_lnk: this.$t('logo_img'),
                org_code: this.$t('code'),
                org_cname: this.$t('cname'),
                link_cname: this.$t('link_cname'),
                link_mobile: this.$t('link_mobile'),
                mod_cname: this.$t('org_mod_cname'),
                join_type_cname: this.$t('join_type_cname'),
                org_status_cdesc: this.$t('status'),
                admin_code: this.$t('admin_code'),
                org_admin_code: this.$t('org_admin_code'),
                addr: this.$t('addr'),
                end_time: this.$t('end_time'),
                add_time: this.$t('add_time'),
                listHeaderEx:{
                    img_lnk: {type:'image',width:120,height:120}
                }
            };
            return{
                mod_cat:this.$base.getModCat(),
                show_subview:false,
                relist:false,
                search:{
                    search_url: "org-down/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    org_cname: '',
                    addr: '',
                    mod_id: '',
                    join_type: '',
                    org_status: '1',
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                mods:[
                    {
                        mod_id:'',
                        mod_cname:this.$t('all')
                    }
                ],
                join_type:[
                    {
                        join_type:'',
                        type_cname:this.$t('all')
                    }
                ],
                org_status:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();

            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function() {
                var data = {};
                this.$base.showLoading();
                this.$request.sendPost("org-down/before-list",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = this.mods.concat(data.mods);
                        this.join_type = this.join_type.concat(data.join_type);
                        this.org_status = this.org_status.concat(data.org_status);
                        this.list();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function() {
                this.$base.exportExcel(this)
            },
            openSave:function (id) {
                this.$base.linkTo('down/save', {id});
            },
            openSetup:function (item) {
                this.$base.linkTo('down/setup', {org_id:item.org_id,org_cname:item.org_cname});
            },
            openAdmin:function (item) {
                this.$base.linkTo('down/admin', {org_id:item.org_id, admin_code:item.admin_code, org_cname:item.org_cname});
            },
            openOrgAdmin:function (item) {
                this.$base.linkTo('down/org_admin', {org_id:item.org_id, org_admin_code:item.org_admin_code, org_cname:item.org_cname});
            },
            openEwm:function (item) {
                this.$base.linkTo('down/ewm',{org_id: item.org_id})
            },
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/down/list.vue